import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  country: string;
  quote: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  country,
  quote,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative" data-id="element-282">
      <Quote className="absolute top-6 right-6 h-8 w-8 text-emerald-100" data-id="element-283" />
      <div className="flex gap-1 mb-4" data-id="element-284">
        {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-285" />)}
      </div>
      <blockquote className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-286">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-287">
        <div className="h-10 w-10 rounded-full bg-slate-200 flex items-center justify-center text-slate-500 font-bold text-sm" data-id="element-288">
          {name.charAt(0)}
        </div>
        <div data-id="element-289">
          <div className="font-semibold text-slate-900" data-id="element-290">{name}</div>
          <div className="text-xs text-slate-500" data-id="element-291">{country}</div>
        </div>
      </div>
      <div className="absolute -bottom-3 right-8 bg-emerald-50 text-emerald-700 text-[10px] px-2 py-0.5 rounded-full border border-emerald-100" data-id="element-292">
        Testimonio (ejemplo)
      </div>
    </motion.div>;
}